// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-button-container-JDsr2 {
  height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 100ms;
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-md);
  padding: 0px 0px 0px 8px;
}

.option-button-container-JDsr2:hover {
  background-color: var(--hover-color);
}

.option-button-container-JDsr2:active {
  background-color: var(--color-neutral-200);
}

.option-button-disabled-JpPxL {
  pointer-events: none;
  opacity: 0.5;
}

.option-button-title-ukVk9 {
  line-height: 32px;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin: 0px 0px 0px 8px;
  white-space: nowrap;
}

.option-button-margin12px-UMYzU {
  margin-right: 12px;
}

.option-button-icon-rVBKh, .option-button-iconRight-aWwgQ {
  --size: 20px;
  color: var(--color-neutral-800);
}

.option-button-iconRight-aWwgQ {
  margin: 0px 4px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/option-button/option-button.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,0CAA0C;EAC1C,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  height: 32px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 100ms;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-md);\n  padding: 0px 0px 0px 8px;\n}\n\n.container:hover {\n  background-color: var(--hover-color);\n}\n\n.container:active {\n  background-color: var(--color-neutral-200);\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.title {\n  line-height: 32px;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin: 0px 0px 0px 8px;\n  white-space: nowrap;\n}\n\n.margin12px {\n  margin-right: 12px;\n}\n\n.icon, .iconRight {\n  --size: 20px;\n  color: var(--color-neutral-800);\n}\n\n.iconRight {\n  margin: 0px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `option-button-container-JDsr2`,
	"disabled": `option-button-disabled-JpPxL`,
	"title": `option-button-title-ukVk9`,
	"margin12px": `option-button-margin12px-UMYzU`,
	"icon": `option-button-icon-rVBKh`,
	"iconRight": `option-button-iconRight-aWwgQ`
};
export default ___CSS_LOADER_EXPORT___;
